<template>
  <div class="opt-serve">
    <div class="serve-name">{{ serveName }}</div>
    <div class="price">¥{{ ruleForm.salePrice }}</div>
    <div class="num">
      <el-input-number size="small" v-model="ruleForm.Qty" :min="1" :max="10" />
    </div>
    <div>
      <el-button plain size="small" class="remove" @click="removeServeClick(ruleForm.serveId, ruleForm.paraId)" type="danger">删除
      </el-button>
    </div>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'

export default defineComponent({
  props: {
    ruleForm: {
      type: Object,
      default() {
        return {}
      }
    },
    serveName: {
      type: String,
      default: ''
    }
  },
  components: {

  },
  emits: ['removeServeClick'],
  setup(props, { emit }) {

    const removeServeClick = (serveId, paraId) => {
      emit('removeServeClick', serveId, paraId)
    }

    return {
      removeServeClick
    }

  }
})
</script>

<style scoped lang="less">
.opt-serve {
  display: flex;
  align-items: center;
  margin: 10px 0;
  padding: 0 10px;
  .num{
    flex: 2;
  }
  div {
    flex: 1;
    padding-left: 6px;
  }

  .remove {
    cursor: pointer;
  }
}
</style>




